// opus-six.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-opus-six',
  templateUrl: './opus-six.component.html',
  styleUrls: ['./opus-six.component.scss']
})
export class OpusSixComponent {
  constructor(private dialogRef: MatDialogRef<OpusSixComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
